import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

// Chrome a screen can take over.
//
// TopbarSlot (in components/index.jsx) already lets a screen put its own search and
// primary action in the top bar. These two are the same idea for the other two pieces of
// shell chrome a screen sometimes owns outright: the breadcrumb, and the context nav.
//
// The assessment editor is the case that needs them. Its context nav is the assessment's
// own categories, not the Business reviews menu, and its breadcrumb names the client and
// the review rather than the screen — because while you are in it, the "screen" you are
// on is that assessment.
//
// Both REPLACE rather than append: shell.css hides the shell's own crumb and nav items
// whenever the matching slot has something in it, so a screen that uses neither is
// completely unaffected.
const useHost = (id) => {
  const [host, setHost] = useState(null);
  useEffect(() => { setHost(document.getElementById(id)); }, [id]);
  return host;
};

export const CrumbSlot = ({ children }) => {
  const host = useHost("v2-crumb-slot");
  return host ? createPortal(children, host) : null;
};

export const NavSlot = ({ children }) => {
  const host = useHost("v2-nav-slot");
  return host ? createPortal(children, host) : null;
};
